import { render } from "./WNvirtualCommerce.vue?vue&type=template&id=562faf34&scoped=true"
import script from "./WNvirtualCommerce.vue?vue&type=script&lang=js"
export * from "./WNvirtualCommerce.vue?vue&type=script&lang=js"

import "./WNvirtualCommerce.vue?vue&type=style&index=0&id=562faf34&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-562faf34"

export default script